module.exports = __webpack_public_path__ + "d63baa3c5438dda0cda3cafc1a61b4cc.png";